import { END_POINT_SEVER } from "../constants";
import axios from "axios";
import {
  SuccessSwal,
  WarningError,
  WarningNetworkFailure,
} from "../helpers/alertseet";
import convertMessage from "../helpers/convertMessage";

export const get_loans = async (findby, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/loan/getAllLoan${findby}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_loan_historys = async (loanId, skip = 0, limit = 1 , token) => {
  try {
    const url = `${END_POINT_SEVER}/api/loan/loan-histories/${loanId}/limit/${limit}/skip/${skip}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const add_loan = async (data, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/loan/create`;
    // const url = `${END_POINT_SEVER}/api/loan/create-loan-test`;
    const res = await axios.post(url, data, {
      headers: { authorization: `Bearer ${token}` },
    });
    SuccessSwal("ສ້າງລາຍການສຳເລັດ!");
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};
export const update_installment = async (installmentId, data, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/loan/updateInstallment/${installmentId}`;
    const res = await axios.put(url, data, {
      headers: { authorization: `Bearer ${token}` },
    });
    SuccessSwal("ອັບເດດລາຍການສຳເລັດ!");
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};
export const update_loan = async (loadId, data, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/loan/update/${loadId}`;
    const res = await axios.put(url, data, {
      headers: { authorization: `Bearer ${token}` },
    });
    SuccessSwal("ອັບເດດຂໍ້ມູນເງິນກູ້ສຳເລັດ!");
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_loan_by_member_id = async (findby, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/loan/getLoanByMemberId${findby}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_loan_by_id = async (_id, findby, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/loan/getLoanById/${_id}${findby}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};
